import { useEffect, useState } from 'react';
import { get } from '../../rest/api';
import { HomeData } from '../../rest/HomeData';
import { URL_API_HOME_PATH } from '../../constants/urls';

export const useHomeData = () => {
  const [data, setData] = useState<HomeData | undefined>();
  const [isLoading, setLoading] = useState<boolean>(true);
  const dataError = !isLoading && (!data || !data.modulos || data.modulos.length === 0);

  function processResponse(data: HomeData | undefined) {
    setData(data);
    setLoading(false);
  }

  function processResponseError() {
    setData(undefined);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    get(URL_API_HOME_PATH, processResponse, processResponseError);
  }, []);

  return [data, isLoading, dataError] as const;
};
